import React from "react";

//COMPONENTS
import ContactForm from "../components/contact/ContactForm";

const Contact = () => {
  return (
    <div>
      <div className="bg-darkBlue">
        <div className="max-w-7xl mx-auto">
          <div className="pb-24 pt-20 sm:pb-48 sm:pt-32 md:pb-60 md:pt-40 flex flex-col items-center">
            <h1 className="header1 text-center text-3xl">
              Contact
              <span className="text-earth"> Us</span>
            </h1>
          </div>
        </div>
      </div>

      <div className="relative -mt-16 mb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="rounded-lg shadow-lg bg-earth">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:grid lg:grid-cols-5 lg:items-center">
              <div className="py-20 px-4 sm:px-6 lg:col-span-2 lg:px-8 xl:pr-12">
                <h2 className="text-3xl font-extrabold tracking-tight text-darkBlue sm:text-4xl">
                  Get in<span className="text-white"> touch</span>
                </h2>
                <p className="mt-3 text-lg leading-6 text-white">
                  To find out more on how we can help your business, please get in
                  touch today.
                </p>
                <dl className="text-base text-white lg:text-xl pt-12">
                  <dt className="sr-only">Postal address</dt>
                  <dd>
                    <p>1st Floor Campion Chambers</p>
                    <p>St Nicholas Square</p>
                    <p>Leicester</p>
                    <p>LE1 4LD</p>
                  </dd>
                </dl>
                <dl className="text-base text-white lg:text-xl pt-12">
                  <div>
                    <dt className="sr-only">Phone number</dt>
                    <dd className="flex items-center text-darkEarth">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                      </svg>
                      <a href="tel:07500493921" className="ml-3 text-white">
                        07500493921
                      </a>
                    </dd>
                  </div>
                  <div className="mt-3">
                    <dt className="sr-only">Email</dt>
                    <dd className="flex items-center text-darkEarth">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                      <a href="mailto:hello@nectar1.co.uk" className="ml-3 text-white">
                        hello@nectar1.co.uk
                      </a>
                    </dd>
                  </div>
                  <div className="mt-3">
                    <dt className="sr-only">LinkedIn</dt>
                    <dd className="flex items-center text-darkEarth">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.647"
                        height="16.647"
                        viewBox="0 0 16.647 16.647"
                        fill="currentColor"
                      >
                        <path
                          id="FontAwsome_linkedin_"
                          data-name="FontAwsome (linkedin)"
                          d="M15.458,32H1.185A1.194,1.194,0,0,0,0,33.2V47.447a1.194,1.194,0,0,0,1.185,1.2H15.458a1.2,1.2,0,0,0,1.189-1.2V33.2A1.2,1.2,0,0,0,15.458,32ZM5.031,46.269H2.564V38.325H5.035v7.945ZM3.8,37.239a1.431,1.431,0,1,1,1.431-1.431A1.431,1.431,0,0,1,3.8,37.239Zm10.483,9.03H11.813V42.4c0-.922-.019-2.107-1.282-2.107-1.286,0-1.483,1-1.483,2.04v3.931H6.581V38.325H8.948V39.41h.033a2.6,2.6,0,0,1,2.337-1.282c2.5,0,2.962,1.646,2.962,3.787Z"
                          transform="translate(0 -32)"
                        />
                      </svg>
                      <a
                        href="https://www.linkedin.com/company/nectar-consulting1/about/"
                        target="_blank"
                        rel="noreferrer"
                        className="ml-3 text-white"
                      >
                        @nectar-consulting1
                      </a>
                    </dd>
                  </div>
                </dl>
              </div>
              <ContactForm />
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
